/* assets/mnl-footer-banners.js
   Manelli-style footer banner carousel (Shopify port)
   - overlay + toggle open/close
   - ultra-smooth touch: native scroll + snap
   - prev/next reliably reaches last slide on desktop
   - desktop grab + drag scrolling
   - details slide-up per item
   - copy promo code + tooltip
*/

(function () {
    function initOne(wrapper) {
        const overlay = document.getElementById("mnl-banners-overlay");
        const toggleBtn = document.querySelector("[data-mnl-toggle]");
        const track = wrapper.querySelector("[data-mnl-track]");

        if (!overlay || !toggleBtn || !track) return;

        const items = Array.from(wrapper.querySelectorAll("[data-mnl-item]"));
        const prevBtn = wrapper.querySelector("[data-mnl-prev]");
        const nextBtn = wrapper.querySelector("[data-mnl-next]");

        let activeIndex = 0;
        let tooltipTimer = null;

        // ---------- OPEN/CLOSE ----------
        function openWidget() {
            wrapper.classList.add("is-open");
            overlay.classList.add("is-open");
            toggleBtn.classList.add("is-open");
            document.documentElement.style.overflow = "hidden";
        }

        function closeWidget() {
            wrapper.classList.remove("is-open");
            overlay.classList.remove("is-open");
            toggleBtn.classList.remove("is-open");
            closeAllDetails();
            document.documentElement.style.overflow = "";
        }

        function toggleWidget() {
            if (wrapper.classList.contains("is-open")) closeWidget();
            else openWidget();
        }

        toggleBtn.addEventListener("click", toggleWidget);
        overlay.addEventListener("click", closeWidget);

        // ---------- DETAILS ----------
        function closeAllDetails() {
            items.forEach((it) => it.classList.remove("is-details-open"));
        }

        // ---------- ACTIVE INDEX (ROBUST) ----------
        function getClosestIndexToLeftEdge() {
            const trackRect = track.getBoundingClientRect();
            let bestIdx = 0;
            let bestDist = Infinity;

            for (let i = 0; i < items.length; i++) {
                const r = items[i].getBoundingClientRect();
                // distance from item's left edge to track left edge
                const dist = Math.abs(r.left - trackRect.left);
                if (dist < bestDist) {
                    bestDist = dist;
                    bestIdx = i;
                }
            }
            return bestIdx;
        }

        function updateActiveFromScroll() {
            const newIdx = getClosestIndexToLeftEdge();
            if (newIdx !== activeIndex) {
                activeIndex = newIdx;
                closeAllDetails(); // like Manelli: change slide closes details
            }
        }

        // rAF throttle scroll handler
        let ticking = false;
        track.addEventListener(
            "scroll",
            () => {
                if (!ticking) {
                    requestAnimationFrame(() => {
                        updateActiveFromScroll();
                        ticking = false;
                    });
                    ticking = true;
                }
            },
            { passive: true }
        );

        // ---------- RELIABLE SCROLL TO INDEX ----------
        function scrollToIndex(i) {
            const idx = Math.max(0, Math.min(items.length - 1, i));
            closeAllDetails();

            // ✅ force state update immediately (fixes "prev not working" cases)
            activeIndex = idx;

            const left = items[idx].offsetLeft;
            track.scrollTo({ left, behavior: "smooth" });

            // ✅ ensure state sync after snap settles
            requestAnimationFrame(() => updateActiveFromScroll());
            setTimeout(updateActiveFromScroll, 120);
        }


        if (prevBtn) {
            prevBtn.addEventListener("click", () => scrollToIndex(activeIndex - 1));
        }
        if (nextBtn) {
            nextBtn.addEventListener("click", () => scrollToIndex(activeIndex + 1));
        }

        // ---------- DESKTOP GRAB + DRAG ----------
        // Uses Pointer Events (mouse + pen), doesn’t break touch.
        let isPointerDown = false;
        let startX = 0;
        let startScrollLeft = 0;
        let dragMoved = false;

        function isInteractiveEl(target) {
            return !!target.closest(
                "a, button, input, textarea, select, label, .details-button, .close-details-button, .code-icon"
            );
        }

        track.addEventListener("pointerdown", (e) => {
            // Only left mouse / primary pointer
            if (e.pointerType === "mouse" && e.button !== 0) return;
            if (isInteractiveEl(e.target)) return;

            isPointerDown = true;
            dragMoved = false;
            startX = e.clientX;
            startScrollLeft = track.scrollLeft;

            track.classList.add("is-dragging");
            track.setPointerCapture(e.pointerId);
        });

        track.addEventListener("pointermove", (e) => {
            if (!isPointerDown) return;
            const dx = e.clientX - startX;
            if (Math.abs(dx) > 2) dragMoved = true;
            track.scrollLeft = startScrollLeft - dx;
        });

        function endDrag(e) {
            if (!isPointerDown) return;
            isPointerDown = false;
            track.classList.remove("is-dragging");

            // If user dragged, prevent accidental click after drag
            if (dragMoved) {
                // snap to nearest after drag ends (depends on CSS scroll-snap)
                // we also update active index after a short delay
                setTimeout(updateActiveFromScroll, 0);
            }
        }

        track.addEventListener("pointerup", endDrag);
        track.addEventListener("pointercancel", endDrag);
        track.addEventListener("pointerleave", endDrag);

        // Prevent click on links when user was dragging (desktop)
        track.addEventListener(
            "click",
            (e) => {
                if (!dragMoved) return;
                if (e.target.closest("a")) {
                    e.preventDefault();
                    e.stopPropagation();
                }
                dragMoved = false;
            },
            true
        );

        // ---------- CLICK HANDLERS (DETAILS + COPY) ----------
        wrapper.addEventListener("click", (e) => {
            const item = e.target.closest("[data-mnl-item]");
            if (!item) return;

            // open details
            const openBtn = e.target.closest("[data-mnl-open-details]");
            if (openBtn) {
                closeAllDetails();
                item.classList.add("is-details-open");
                return;
            }

            // close details
            const closeBtn = e.target.closest("[data-mnl-close-details]");
            if (closeBtn) {
                item.classList.remove("is-details-open");
                return;
            }

            // copy promo code
            const copyBtn = e.target.closest("[data-mnl-copy]");
            if (copyBtn) {
                const codeWrap = item.querySelector("[data-mnl-code]");
                const tooltip = item.querySelector("[data-mnl-tooltip]");
                const code = codeWrap ? codeWrap.getAttribute("data-code") : "";
                if (!code) return;

                const showTooltip = () => {
                    if (!tooltip) return;
                    tooltip.style.display = "block";
                    clearTimeout(tooltipTimer);
                    tooltipTimer = setTimeout(() => {
                        tooltip.style.display = "none";
                    }, 2000);
                };

                const fallbackCopy = () => {
                    try {
                        const ta = document.createElement("textarea");
                        ta.value = code;
                        ta.setAttribute("readonly", "");
                        ta.style.position = "fixed";
                        ta.style.left = "-9999px";
                        document.body.appendChild(ta);
                        ta.select();
                        document.execCommand("copy");
                        document.body.removeChild(ta);
                        showTooltip();
                    } catch (err) { }
                };

                if (navigator.clipboard && navigator.clipboard.writeText) {
                    navigator.clipboard.writeText(code).then(showTooltip).catch(fallbackCopy);
                } else {
                    fallbackCopy();
                }
            }
        });

        // ---------- INIT ----------
        // Start closed by default
        closeWidget();

        // Make sure activeIndex is correct once layout is ready
        setTimeout(() => {
            updateActiveFromScroll();
        }, 0);
    }

    document.addEventListener("DOMContentLoaded", () => {
        const wrapper = document.querySelector("[data-mnl-wrapper]");
        if (wrapper) initOne(wrapper);
    });
})();
